module.exports = __webpack_public_path__ + "static/step-4-7069a3c8d4d7d4b4bf5ff6e01e5eeb65.jpg";